import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import adminApi from '../../../APIs/admin';
import { Typography } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { requestAPI } from '../../../utils';

type Props = {};

const Assignto = (_props: Props) => {
  const departmentUsers = useSelector(
    (state: RootState) => state.departmentUsersData.data,
  );
  const getDepartmentUsers = async () => {
    try {
      await requestAPI(adminApi.getDepartmentUsers());
    } catch (error) {
      console.error(error);
    }
  };
  const options = departmentUsers
    .filter((user) => user.permissions === 'FIREMAN')
    .map((user) => ({
      id: user._id,
      value: user._id,
      label: user.fullName,
    }));
  console.log(options);

  useEffect(() => {
    getDepartmentUsers();
  }, []);
  return (
    <div>
      <Typography size={20}>Assign To</Typography>
    </div>
  );
};

export default Assignto;
